import React from 'react';
import cn from 'classnames';
import {useTranslation} from 'react-i18next';

import Form from 'components/common/Form';
import Select from 'components/common/Form/Select';
import Input from 'components/common/Form/Input';
import Button, {ButtonStyles} from 'components/common/Form/Button';

import {NO_COMPANY_STATUSES, TranslateEmployment} from 'constants/Experience';
import {convertToOptions, convertToValue} from 'helpers/SelectUtils';
import YearsOfExperience from 'constants/YearsOfExperience';

import style from 'components/Welcome/Form/Form.module.scss';
import OptionSlider from 'components/common/Form/OptionSlider/OptionSlider';

export default function WorkDetailsForm({onChange, onNextStep, data, isLastStep, errors, validate, isModal}) {
    const {employmentStatus, workExperience, company, occupation} = data;
    const {t} = useTranslation();

    const showCompanyField = employmentStatus && !NO_COMPANY_STATUSES.includes(employmentStatus);
    return (
        <div className={style.profileFormContainer}>
            <Form className={cn(style.form, {[style.modal]: isModal})}>
                <div className={cn(style.inlineFieldsContainer, style.upperSelect)}>
                    <Select
                        label={t('welcome:form.labels.employment')}
                        placeholder={t('welcome:form.placeholders.employment')}
                        options={convertToOptions(TranslateEmployment(t))}
                        value={convertToValue(employmentStatus, TranslateEmployment(t))}
                        onChange={onChange.bind(this, 'employmentStatus')}
                        error={t(errors.employmentStatus)}
                        className={style.selectWide}
                        labelClassName={style.labelClassName}
                        onBlur={validate.bind(this, data, 'employmentStatus')}
                    />
                </div>
                {showCompanyField && (
                    <div className={style.inlineFieldsContainer}>
                        <Input
                            label={t('welcome:form.labels.company')}
                            placeholder={t('welcome:form.placeholders.company')}
                            value={company}
                            onChange={onChange.bind(this, 'company')}
                            error={t(errors.company)}
                            name='company'
                            labelClassName={style.labelClassName}
                            onBlur={validate.bind(this, data, 'company')}
                        />
                        <Input
                            label={t('welcome:form.labels.occupation')}
                            placeholder={t('welcome:form.placeholders.occupation')}
                            value={occupation}
                            onChange={onChange.bind(this, 'occupation')}
                            error={t(errors.occupation)}
                            name='occupationcompany'
                            labelClassName={style.labelClassName}
                            onBlur={validate.bind(this, data, 'occupation')}
                        />
                    </div>
                )}
                <div className={style.inlineFieldsContainer}>
                    <OptionSlider
                        options={YearsOfExperience}
                        className={style.experience}
                        label={t('welcome:form.labels.experience')}
                        width={37}
                        onChange={onChange.bind(this, 'workExperience')}
                        value={workExperience}
                        error={t(errors.workExperience)}
                        onBlur={validate.bind(this, data, 'workExperience')}
                    />
                </div>
                {isLastStep && <div className={style.commonError}>{errors.common}</div>}
                <div className={cn(style.buttonWrapper, style.withBottomMargin)}>
                    <Button
                        text={isLastStep ? t('welcome:buttons.getStarted') : t('welcome:buttons.continue')}
                        onClick={onNextStep}
                        btnStyle={ButtonStyles.primary}
                    />
                </div>
            </Form>
        </div>
    );
}
